import type { ReactNode } from "react";
import {
  type PeekEntity,
  useEntityPeek,
} from "@/components/shared/relationships/entity-peek-context";
import { cn } from "@/components/ui/utils";

interface EntityLinkProps {
  children?: ReactNode;
  className?: string;
  entity: PeekEntity;
}

/**
 * Clickable text link that opens an entity in the shared quick-view peek
 * dialog. When rendered inside an already-open peek (stack non-empty), the
 * click chains onto the stack instead of replacing it, so a link clicked
 * from within a peek's content navigates in place with breadcrumbs.
 */
export function EntityLink({ children, className, entity }: EntityLinkProps) {
  const { open, push, stack } = useEntityPeek();
  const isInsidePeek = stack.length > 0;

  return (
    <button
      className={cn("text-primary hover:underline", className)}
      onClick={(event) => {
        event.stopPropagation();
        if (isInsidePeek) {
          push(entity);
        } else {
          open(entity);
        }
      }}
      type="button"
    >
      {children ?? entity.label ?? entity.type}
    </button>
  );
}
